/* eslint-disable import/no-extraneous-dependencies */
'use client';
import { useEffect, useRef } from 'react';
import { unmountSlots } from './googletag';
import cx from 'classnames';
import { ImageSkeleton } from '@/components/atoms/Skeleton';

/* eslint-disable-next-line */
export type Profile = {
  name: string;
  path: string;
  size: (number | string)[][];
  checkAdIsLoaded?: boolean; // 載入後x秒會檢查是否有iframe元素，如果沒有會執行refresh重載廣告
  enabledDefaultHeight?: boolean;
};

type AdslotProps = {
  profile: Profile;
  style?: string;
};

declare global {
  interface Window {
    googletag: any;
  }
}

export function AdSlot({ profile, style }: AdslotProps) {
  const { name, size, path } = profile;
  const slotId = `div-gpt-ad-${name}`;
  const slot = useRef(null);
  const [width, height] = size?.[0];
  const skeletonStyle = width && height ? `w-[${width}px] h-[${height}px]` : null;

  const init = () => {
    const googletag = window.googletag || null;

    if (googletag) {
      // 註冊廣告版位: https://developers.google.com/publisher-tag/guides/get-started?hl=zh-tw
      googletag.cmd?.push(function () {
        slot.current = googletag?.defineSlot(path, size, slotId)?.addService(googletag.pubads());
        googletag.enableServices();

        // 顯示廣告
        googletag.display(slotId);
      });
    }
  };

  useEffect(() => {
    init();

    return () => {
      unmountSlots(slot?.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={slotId} className={cx(skeletonStyle, style)}>
      <ImageSkeleton height='100%' width='100%' />
    </div>
  );
}

export default AdSlot;
